import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectRoutingModule } from './project-routing.module';
import { ProjectComponent } from './components/project/project.component';
import { SharedModule } from '../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { DiscrepanciesEffects } from '../discrepancies/store/discrepancies.effects';
import { SpaProjectEffects } from '../spa/store/spa-project.effects';
import { UserEffect } from '../users/store/user.effect';
import { ProjectFiltersEffects } from '../spa/store/project-filters/project-filters.effects';
import { CompareEffects } from '../discrepancies/store/compare/compare.effects';
import { ParameterEffect } from '../parameters/store/parameter.effect';
import { CheckEffect } from '../checks/store/check.effect';
import { TrackerEffects } from '../tracker/store/tracker.effects';
import { ValidationEffects } from '../validation/store/validation/validation.effects';
import { ProjectLabelsEffects } from '../validation/store/project-labels/project-labels.effects';
import { CssClassPipe } from '../shared/pipes/css-class.pipe';
import { SettingsEffect } from '../settings/store/settings.effect';

@NgModule({
  declarations: [ProjectComponent],
  imports: [
    CommonModule,
    ProjectRoutingModule,
    SharedModule,
    EffectsModule.forFeature([
      DiscrepanciesEffects,
      TrackerEffects,
      SpaProjectEffects,
      UserEffect,
      ProjectFiltersEffects,
      CompareEffects,
      ParameterEffect,
      CheckEffect,
      ValidationEffects,
      ProjectLabelsEffects,
      SettingsEffect
    ]),
    CssClassPipe
  ]
})
export class ProjectModule {}
